export default __webpack_public_path__ + "static/media/folder-open-icon.1cfc16f8.svg";